<template>
  <div v-if="showAlertForSmallScreen" class="alert-small-screen">
    <p>This site is only supported on larger screens. Please use a desktop or maximize your browser window.</p>
  </div>
  <div class="big-404" v-show="!showAlertForSmallScreen">
    <h4 class="self-404"><span style="color: #A51C30">4</span><span style="color: #A51C30">0</span><span style="color: #A51C30">4</span></h4>
  </div>
</template>

<script>
import { smallScreenMixin } from '@/mixins/smallScreenMixin';

export default {
  name: "NotFound",
  mixins: [smallScreenMixin]
};
</script>

<style>
.big-404 {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-top: 5rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-family: Ubuntu;
}
.big-404-title {
  text-align: center;
  position: absolute;
  font-size: 2rem;
  top: 200px;
}
.big-404-title p {
  margin-top: 33px;
}
.big-404-title .small {
  font-size: 1rem;
}
.self-404 {
  font-size: 25rem;
}
.alert-small-screen {
  font-size: 1.3rem;
  width: 90vw;
  margin: 0 auto;
  text-align: center;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>